import { fg } from '@atlassian/jira-feature-gating';

// eslint-disable-next-line jira/ff/inline-usage
export const getIsPreviewPanelEnabled = () => fg('jira-glance-panel');
